import { Injectable } from '@angular/core';
import { DataReactionAction } from '@osos/shared/api';
import { DataEntityActionPresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../bases/parser/parser-base';

@Injectable()
export class DataEntityActionParserV1Service extends ParserBase<
  DataReactionAction,
  DataEntityActionPresenterModel
> {
  constructor() {
    super(DataReactionAction, DataEntityActionPresenterModel, 1);
  }

  getPresenterModel(model: DataReactionAction): DataEntityActionPresenterModel {
    const presenter = {} as DataEntityActionPresenterModel;
    presenter.id = model.id;
    presenter.name = model.name;
    presenter.normalizedName = model.normalizedName;
    presenter.actionType = model.actionType;
    presenter.options = model.options;
    presenter.resultField = model.resultField;
    presenter.overridableOptions = model.overridableOptions;
    return presenter;
  }
  getDataModel(presenter: DataEntityActionPresenterModel): DataReactionAction {
    const model = {
      id: presenter?.id,
      name: presenter.name,
      normalizedName: presenter.normalizedName,
      actionType: presenter.actionType,
      options: { ...presenter.options, module: undefined },
      resultField: presenter.resultField,
      overridableOptions: presenter.overridableOptions,
    } as DataReactionAction;

    return model;
  }
}
